<!-- Page overlay: keep outside animated/transformed ancestors so fixed covers the viewport -->
<app-pss-loading *ngIf="isLoadingDetail() || isSearching()"></app-pss-loading>

<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <!-- Page header -->
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">ให้ส่วนลด (Stamp)</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        ค้นหาทะเบียนรถที่ยังอยู่ในลาน แล้วเลือกตราประทับเพื่อให้ส่วนลด
      </p>
    </div>
  </div>

  <!-- Card -->
  <div
    class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden">

    <!-- Card header -->
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">confirmation_number</span>ข้อมูลการค้นหา
      </h3>
      <span *ngIf="siteState.selectedSite()?.name"
        class="inline-flex items-center gap-1 mt-2 px-2.5 py-1 rounded-full bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 text-xs font-bold">
        <span class="material-icons text-[14px]">local_parking</span>{{ siteState.selectedSite()?.name }}
      </span>
    </div>

    <!-- Search form -->
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700">
      <div class="max-w-2xl">
        <label class="block text-xs font-bold text-slate-500 dark:text-slate-400 mb-2">
          ทะเบียนรถ <span class="text-rose-500">*</span>
        </label>
        <div
          class="relative flex items-center h-[52px] bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 focus-within:border-amber-300 transition-all">
          <span class="absolute left-4 material-icons text-slate-400 text-[20px]">directions_car</span>
          <input type="text" [(ngModel)]="licenseInput" (keyup.enter)="onSearch()"
            placeholder="เช่น กส1234 / BALL001" autocomplete="off"
            class="w-full h-full pl-12 pr-4 bg-transparent border-none text-base font-bold uppercase tracking-wide text-slate-800 dark:text-slate-100 focus:outline-none" />
        </div>
        <p class="text-[11px] text-slate-400 mt-2">กรอกทะเบียนรถที่ยังไม่ออกจากลาน แล้วกดค้นหา หรือ Enter</p>

        <div class="flex flex-col sm:flex-row gap-3 mt-5">
          <button type="button" (click)="onSearch()" [disabled]="isSearching()"
            class="h-[48px] px-8 bg-amber-400 hover:bg-amber-500 disabled:opacity-50 text-white font-bold rounded-xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center justify-center gap-2 cursor-pointer border-none">
            <span class="material-icons text-[20px]">{{ isSearching() ? 'hourglass_top' : 'search' }}</span>
            {{ isSearching() ? 'กำลังค้นหา...' : 'ค้นหา' }}
          </button>
          <button type="button" (click)="onClear()"
            class="h-[48px] px-6 bg-white dark:bg-slate-900 hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-300 font-bold rounded-xl border border-slate-200 dark:border-slate-700 transition-all flex items-center justify-center gap-2 cursor-pointer">
            <span class="material-icons text-[20px]">restart_alt</span>
            ล้างฟอร์ม
          </button>
        </div>
      </div>
    </div>

    <!-- Empty state -->
    <section *ngIf="!isLoadingDetail() && !detail()" class="px-6 md:px-8 py-10 text-center">
      <div
        class="w-14 h-14 mx-auto rounded-2xl bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 flex items-center justify-center mb-3">
        <span class="material-icons text-slate-300 dark:text-slate-600 text-[28px]">assignment</span>
      </div>
      <p class="text-sm font-bold text-slate-500 dark:text-slate-400">ยังไม่ได้เลือกรถ</p>
      <p class="text-xs text-slate-400 mt-1 max-w-sm mx-auto leading-relaxed">
        ค้นหาทะเบียนด้านบน แล้วเลือกรายการจากผลค้นหาเพื่อกรอกรายละเอียดและให้ส่วนลด
      </p>
    </section>

    <!-- Detail + actions -->
      <ng-container *ngIf="!isLoadingDetail() && detail() as d">
        <section class="p-6 border-b border-slate-100 dark:border-slate-700">
          <div class="flex items-center justify-between gap-3 mb-4">
            <div class="min-w-0">
              <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
                <span class="material-icons text-amber-500">directions_car</span>รายละเอียดรถ
              </h3>
              <p class="text-xs text-slate-400 mt-1">ตรวจสอบข้อมูลก่อนให้ส่วนลด</p>
            </div>
            <button type="button" (click)="clearSelection()" title="ล้างรายการที่เลือก"
              class="w-10 h-10 rounded-xl text-rose-400 hover:bg-rose-50 dark:hover:bg-rose-900/20 border-none bg-transparent cursor-pointer flex items-center justify-center transition-all shrink-0">
              <span class="material-icons">delete_outline</span>
            </button>
          </div>

          <!-- Wide 2-column: vehicle + info/amounts -->
          <div class="grid grid-cols-1 lg:grid-cols-[280px_1fr] gap-4 lg:gap-5">
            <!-- Vehicle card -->
            <div
              class="flex flex-col gap-3 p-4 rounded-2xl bg-gradient-to-br from-amber-50 to-orange-50/60 dark:from-amber-900/20 dark:to-slate-900 border border-amber-100/80 dark:border-amber-900/40">
              <div
                class="w-full h-36 rounded-xl bg-white/80 dark:bg-slate-800 overflow-hidden border border-amber-100/60 dark:border-slate-700 flex items-center justify-center">
                <img [src]="photoUrl(selectedSearchItem())" alt="entry"
                  class="w-full h-full object-cover"
                  (error)="$any($event.target).src='img/notfound.jpg'" />
              </div>
              <div>
                <span
                  class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-400 text-[11px] font-bold mb-2">
                  <span class="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
                  ยังอยู่ในลาน
                </span>
                <div class="text-[11px] font-bold text-amber-700/70 dark:text-amber-400/80 uppercase tracking-wider">
                  ทะเบียนรถ
                </div>
                <div class="text-2xl font-black text-slate-900 dark:text-white tracking-tight mt-0.5 break-all">
                  {{ d.entryLicense || '—' }}
                </div>
              </div>
            </div>

            <!-- Fields + amounts -->
            <div class="flex flex-col gap-4 min-w-0">
              <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <div
                  class="rounded-2xl bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 px-4 py-3">
                  <div class="flex items-center gap-1.5 text-[11px] font-bold text-slate-400 uppercase tracking-wider mb-1">
                    <span class="material-icons text-[14px]">login</span>
                    วัน-เวลาที่เข้า
                  </div>
                  <div class="text-sm font-bold text-slate-800 dark:text-slate-100">
                    {{ d.entryDate ? (d.entryDate | date:'dd/MM/yyyy HH:mm') : '—' }}
                  </div>
                </div>
                <div
                  class="rounded-2xl bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 px-4 py-3">
                  <div class="flex items-center gap-1.5 text-[11px] font-bold text-slate-400 uppercase tracking-wider mb-1">
                    <span class="material-icons text-[14px]">category</span>
                    ประเภทรถ
                  </div>
                  <div class="text-sm font-bold text-slate-800 dark:text-slate-100">
                    {{ selectedSearchItem()?.vehicleTypeName || '—' }}
                  </div>
                </div>
                <div
                  class="rounded-2xl bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 px-4 py-3">
                  <div class="flex items-center gap-1.5 text-[11px] font-bold text-slate-400 uppercase tracking-wider mb-1">
                    <span class="material-icons text-[14px]">schedule</span>
                    ระยะเวลาจอด
                  </div>
                  <div class="text-sm font-bold text-slate-800 dark:text-slate-100">{{ durationText }}</div>
                </div>
              </div>

              <div>
                <div class="text-[11px] font-bold text-slate-400 uppercase tracking-wider mb-2 flex items-center gap-1.5">
                  <span class="material-icons text-[14px]">payments</span>
                  ยอดเงิน (บาท)
                </div>
                <div class="grid grid-cols-3 gap-3">
                  <div
                    class="rounded-2xl bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-700 p-3 text-center">
                    <div class="text-[10px] font-bold text-slate-400 mb-1">ค่าจอด</div>
                    <div class="text-lg font-black text-slate-800 dark:text-slate-100 tabular-nums">
                      {{ (pricing?.parkingFee ?? 0) | number:'1.0-2' }}
                    </div>
                  </div>
                  <div
                    class="rounded-2xl bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-100 dark:border-emerald-900/40 p-3 text-center">
                    <div class="text-[10px] font-bold text-emerald-600/80 dark:text-emerald-400/80 mb-1">ชำระแล้ว</div>
                    <div class="text-lg font-black text-emerald-700 dark:text-emerald-400 tabular-nums">
                      {{ (pricing?.paidParking ?? 0) | number:'1.0-2' }}
                    </div>
                  </div>
                  <div
                    class="rounded-2xl bg-amber-50 dark:bg-amber-900/25 border border-amber-200/70 dark:border-amber-900/40 p-3 text-center">
                    <div class="text-[10px] font-bold text-amber-700/80 dark:text-amber-400/80 mb-1">ที่ต้องชำระ</div>
                    <div class="text-lg font-black text-amber-700 dark:text-amber-400 tabular-nums">
                      {{ (pricing?.totalPay ?? 0) | number:'1.0-2' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Step 3: Actions (inline compact) -->
        <section class="px-6 py-4 bg-slate-50/80 dark:bg-slate-900/40">
          <div class="flex flex-col lg:flex-row lg:items-center gap-4">
            <div class="shrink-0">
              <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
                <span class="material-icons text-amber-500">loyalty</span>ดำเนินการ
              </h3>
              <p class="text-xs text-slate-400 mt-1">ดูส่วนลดที่มี หรือให้ตราประทับใหม่</p>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 flex-1 lg:max-w-xl lg:ml-auto">
              <button type="button" (click)="openAllDiscounts()"
                class="h-12 px-5 rounded-2xl bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm font-bold border border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 hover:shadow-md cursor-pointer flex items-center justify-center gap-2 transition-all">
                <span class="material-icons text-slate-400 text-[20px]">list_alt</span>
                ส่วนลดทั้งหมด
              </button>
              <button type="button" (click)="openAllAvailableStamps()"
                class="h-12 px-5 rounded-2xl bg-amber-400 hover:bg-amber-500 text-slate-900 text-sm font-black border-none cursor-pointer flex items-center justify-center gap-2 shadow-lg shadow-amber-200/40 dark:shadow-none transition-all">
                <span class="material-icons text-[20px]">loyalty</span>
                ให้ตราประทับ
              </button>
            </div>
          </div>
        </section>
      </ng-container>
  </div>
</div>

<!-- Select list modal -->
<div *ngIf="showSelectModal()"
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md"
  (click)="closeSelectModal()">
  <div
    class="w-full max-w-xl max-h-[85vh] bg-white dark:bg-slate-900 rounded-[2rem] shadow-2xl border border-slate-100 dark:border-slate-800 overflow-hidden flex flex-col"
    (click)="$event.stopPropagation()">
    <div class="flex items-start justify-between px-6 py-5 border-b border-slate-100 dark:border-slate-800 bg-amber-50/40 dark:bg-amber-900/10">
      <div class="flex items-start gap-3">
        <div class="w-10 h-10 rounded-xl bg-amber-400 text-slate-900 flex items-center justify-center shrink-0">
          <span class="material-icons text-[20px]">playlist_add_check</span>
        </div>
        <div>
          <h2 class="text-lg font-black text-slate-900 dark:text-white">เลือกรายการที่พบ</h2>
          <p class="text-sm text-slate-400 mt-1">
            พบ {{ searchResults().length }} รายการ · รถยังไม่ออกจากลาน
          </p>
        </div>
      </div>
      <button type="button" (click)="closeSelectModal()"
        class="w-9 h-9 rounded-xl text-slate-400 hover:bg-white dark:hover:bg-slate-800 border-none bg-transparent cursor-pointer flex items-center justify-center">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto custom-scrollbar p-4 space-y-3">
      <button type="button" *ngFor="let item of searchResults(); let i = index"
        (click)="selectSearchItem(item)"
        class="w-full text-left rounded-2xl border border-slate-100 dark:border-slate-800 bg-white dark:bg-slate-900 p-4 flex gap-4 hover:border-amber-300 hover:bg-amber-50/40 dark:hover:bg-amber-900/10 transition-all cursor-pointer">
        <div
          class="w-24 h-20 rounded-xl bg-slate-100 dark:bg-slate-800 overflow-hidden shrink-0 flex items-center justify-center border border-slate-100 dark:border-slate-700">
          <img [src]="photoUrl(item)" alt="entry" class="w-full h-full object-cover"
            (error)="$any($event.target).src='img/notfound.jpg'" />
        </div>
        <div class="flex-1 min-w-0">
          <div class="text-[11px] font-bold text-amber-600 dark:text-amber-400 mb-1">รายการที่ {{ i + 1 }}</div>
          <div class="text-lg font-black text-slate-900 dark:text-white tracking-tight truncate">
            {{ item.entryLicense }}
          </div>
          <div class="text-xs text-slate-500 mt-1.5 flex items-center gap-1">
            <span class="material-icons text-[14px]">login</span>
            {{ item.entryDate ? (item.entryDate | date:'dd/MM/yyyy HH:mm') : '—' }}
          </div>
          <div class="text-xs text-slate-500 mt-0.5 flex items-center gap-1">
            <span class="material-icons text-[14px]">category</span>
            {{ item.vehicleTypeName || '—' }}
          </div>
          <div class="mt-3 flex justify-end">
            <span
              class="inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-bold bg-amber-100 text-amber-900 dark:bg-amber-900/40 dark:text-amber-300">
              แตะเพื่อเลือก
              <span class="material-icons text-[14px]">arrow_forward</span>
            </span>
          </div>
        </div>
      </button>
    </div>
  </div>
</div>

<!-- Stamp picker modal -->
<div *ngIf="showStampModal()"
  class="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md"
  (click)="closeStampModal()">
  <div
    class="w-full max-w-lg max-h-[85vh] bg-white dark:bg-slate-900 rounded-[2rem] shadow-2xl border border-slate-100 dark:border-slate-800 flex flex-col overflow-hidden"
    (click)="$event.stopPropagation()">
    <div class="px-6 py-5 border-b border-slate-100 dark:border-slate-800 bg-amber-50/40 dark:bg-amber-900/10 flex items-start justify-between gap-3">
      <div class="flex items-start gap-3">
        <div class="w-10 h-10 rounded-xl bg-amber-400 text-slate-900 flex items-center justify-center shrink-0">
          <span class="material-icons text-[20px]">loyalty</span>
        </div>
        <div>
          <h3 class="text-lg font-black text-slate-900 dark:text-white">{{ pickerTitle() }}</h3>
          <p class="text-xs text-slate-400 mt-1">เลือกตราที่ใช้ได้ แล้วใส่หมายเหตุได้ถ้าต้องการ</p>
        </div>
      </div>
      <button type="button" (click)="closeStampModal()"
        class="w-9 h-9 rounded-xl text-slate-400 hover:bg-white dark:hover:bg-slate-800 border-none bg-transparent cursor-pointer flex items-center justify-center shrink-0">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto custom-scrollbar p-4 space-y-2">
      <label *ngFor="let s of pickerStamps()"
        class="flex items-start gap-3 p-3.5 rounded-2xl border cursor-pointer transition-all"
        [ngClass]="selectedStampId() === s.parkingRateId
          ? 'border-amber-400 bg-amber-50 dark:bg-amber-900/20 shadow-sm shadow-amber-100 dark:shadow-none'
          : 'border-slate-100 dark:border-slate-800 hover:bg-slate-50 dark:hover:bg-slate-800/50'">
        <input type="radio" name="stampPick" class="mt-1 accent-amber-500"
          [checked]="selectedStampId() === s.parkingRateId"
          (change)="selectStamp(s.parkingRateId)" />
        <div class="min-w-0">
          <div class="text-sm font-bold text-slate-800 dark:text-slate-100">
            {{ s.rateName || s.rateId || ('#' + s.parkingRateId) }}
          </div>
          <div class="text-xs text-slate-400 mt-0.5">
            {{ s.groupName || 'กลุ่ม' }} · {{ s.costType }}
            <span *ngIf="s.remainingQty != null"> · เหลือ {{ s.remainingQty }}</span>
          </div>
        </div>
      </label>
    </div>

    <div class="px-5 py-4 border-t border-slate-100 dark:border-slate-800 space-y-3 bg-slate-50/60 dark:bg-slate-900/40">
      <label class="block text-[11px] font-bold text-slate-400 uppercase tracking-wider">หมายเหตุ</label>
      <div
        class="relative flex items-center bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
        <span class="absolute left-3 material-icons text-slate-400 text-[18px]">notes</span>
        <input type="text" [(ngModel)]="stampRemark" placeholder="ถ้ามี (ไม่บังคับ)"
          class="w-full h-full pl-10 pr-3 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none" />
      </div>
      <div class="flex justify-end gap-2 pt-1">
        <button type="button" (click)="closeStampModal()"
          class="px-4 py-2.5 rounded-xl text-sm font-bold bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border-none cursor-pointer">
          ยกเลิก
        </button>
        <button type="button" (click)="confirmApplyStamp()" [disabled]="isApplying() || !selectedStampId()"
          class="px-5 py-2.5 rounded-xl text-sm font-black bg-amber-400 hover:bg-amber-500 disabled:opacity-50 text-slate-900 border-none cursor-pointer shadow-md shadow-amber-200/40 dark:shadow-none">
          {{ isApplying() ? 'กำลังบันทึก...' : 'ตกลง' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- All discounts modal -->
<div *ngIf="showDiscountsModal()"
  class="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md"
  (click)="closeDiscountsModal()">
  <div
    class="w-full max-w-lg max-h-[85vh] bg-white dark:bg-slate-900 rounded-[2rem] shadow-2xl border border-slate-100 dark:border-slate-800 flex flex-col overflow-hidden"
    (click)="$event.stopPropagation()">
    <div class="px-6 py-5 border-b border-slate-100 dark:border-slate-800 bg-amber-50/40 dark:bg-amber-900/10 flex items-start justify-between gap-3">
      <div class="flex items-start gap-3">
        <div class="w-10 h-10 rounded-xl bg-amber-400 text-slate-900 flex items-center justify-center shrink-0">
          <span class="material-icons text-[20px]">list_alt</span>
        </div>
        <div>
          <h3 class="text-lg font-black text-slate-900 dark:text-white">ส่วนลดทั้งหมด</h3>
          <p class="text-xs text-slate-400 mt-1">Taiwan pricing + parking_web_stamp</p>
        </div>
      </div>
      <button type="button" (click)="closeDiscountsModal()"
        class="w-9 h-9 rounded-xl text-slate-400 hover:bg-white dark:hover:bg-slate-800 border-none bg-transparent cursor-pointer flex items-center justify-center shrink-0">
        <span class="material-icons">close</span>
      </button>
    </div>
    <div class="flex-1 overflow-y-auto custom-scrollbar p-4 space-y-2.5">
      <div *ngFor="let item of appliedDiscounts()"
        class="rounded-2xl border border-slate-100 dark:border-slate-800 p-3.5 bg-white dark:bg-slate-900">
        <div class="flex items-start justify-between gap-3">
          <div class="min-w-0">
            <span class="inline-flex px-2 py-0.5 rounded-md text-[10px] font-bold mb-1.5"
              [ngClass]="item.source === 'taiwan'
                ? 'bg-sky-50 text-sky-600 dark:bg-sky-900/30 dark:text-sky-400'
                : 'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400'">
              {{ item.source === 'taiwan' ? 'Taiwan' : 'Stamp' }}
            </span>
            <div class="text-sm font-bold text-slate-800 dark:text-slate-100 truncate">{{ item.title }}</div>
            <div class="text-xs text-slate-400 mt-0.5">{{ item.subTitle }}</div>
            <div class="text-[11px] text-slate-400 mt-1" *ngIf="item.at">
              {{ item.at | date:'dd/MM/yyyy HH:mm' }}
            </div>
          </div>
          <div class="text-sm font-black text-emerald-600 dark:text-emerald-400 shrink-0">{{ item.amountLabel }}</div>
        </div>
      </div>
      <div *ngIf="appliedDiscounts().length === 0" class="py-14 text-center">
        <span class="material-icons text-slate-300 text-[36px] mb-2">inbox</span>
        <p class="text-sm text-slate-400 italic">ยังไม่มีส่วนลดบนรายการนี้</p>
      </div>
    </div>
  </div>
</div>
